import router from './index.js'
import store from '../store/index.js'
import { adminroutes } from './admin.js'
import { agentroutes } from './agent.js'
import menuRuntime from './menuRuntime.js'
import { resolveBootstrapDecision } from './menuRuntime.core.js'
import { tim, imInit, IMlogin, TIM } from '@/util/im.js';
import authSession from "@/util/authSession.js";

// ,'/apply/wechat','/apply/login'
const whitelist = [
	'/login',
	'/carlogin',
	'/carRowLogin',
	'/apply/wechat', '/apply/login',
	'/adminlogin',
	'/arealogin',
	'/agreement',
	'/userlogin',
	'/cleanlogin',
	'/tescologin',
	'/foodlogin',
	'/recruitlogin',
	'/recruitlogins',
	'/parklogins',
	'/shoplogin',
	'/servicelogin',
	'/easylogin',
	'/sharinglogin',
	'/retaillogin',
	'/orangelogin',
	'/psychologicalLogin',
	'/gallerylogin',
	'/shopMlogin',
	'/weishoplogin',
	'/regionlogin',
	'/supplierlogin',
	'/merchantslogin',
	'/agentlogin',
	'/index/createStore',
	'/index/createStore_user',
	'/register',
	'/forget',
	'/contract'
	
]
// im初始化角色表
const role = [83, 80]
let bootstrappedPath = null

function debugEnabled() {
	try {
		return window.localStorage && window.localStorage.getItem('loginBootstrapDebug') === '1'
	} catch (e) {
		return false
	}
}

function debugNow() {
	return window.performance && window.performance.now ? window.performance.now() : Date.now()
}

function debugLog(event, payload) {
	if (debugEnabled()) {
		console.log('[login-bootstrap]', event, payload || {})
	}
}

router.beforeEach((to, from, next) => {
	const guardStart = debugNow()
	authSession.restoreSnapshotIfNeeded() // 新窗口：据 localStorage 快照同步补水到本窗口 sessionStorage
	let token = sessionStorage.getItem('token')
	let routes = sessionStorage.getItem('routes') //原始路由
	authSession.captureSnapshot() // 已登录则快照当前会话（进程内去重；未登录自动 no-op）
	let pluginroute = sessionStorage.getItem('pluginroute') //插件路由
	let pluginid = sessionStorage.getItem('pluginid') //插件id
	debugLog('guard:enter', {
		from: from.fullPath,
		to: to.fullPath,
		matched: to.matched.length,
		routeadds: store.state.routeadds,
		hasToken: Boolean(token),
		hasRoutes: Boolean(routes),
		routesBytes: routes ? routes.length : 0,
		bootstrappedPath
	})
	to.meta.keepAlive && store.commit("addIncludeAlive", to.name)
	if (to.path == '/') {
		debugLog('guard:root-redirect', {
			elapsed: Math.round(debugNow() - guardStart)
		})
		next({ path: "/login" });
		return
	}

	let userinfo = JSON.parse(sessionStorage.getItem('userinfo'))
	let IMtoken = sessionStorage.getItem('IMtoken')

	if (IMtoken && userinfo && Array.isArray(userinfo.roles) && userinfo.roles.length > 0 && store.state.ImStatus.imlogin == false) {

		console.log(store.state.ImStatus.imlogin, '---store')

		let is_role = role.findIndex(item => {
			return item == userinfo.roles[0].id
		})

		if (is_role != -1) {
			imInit(1400635745, 0)

		}
	}
	if (token && routes) {
		let routeadds = store.state.routeadds
		const scopedPath = menuRuntime.resolveScopedPath(from.path, to.path)
		if (scopedPath && scopedPath !== to.path) {
			debugLog('guard:scoped-redirect', {
				from: from.fullPath,
				to: to.fullPath,
				scopedPath
			})
			next({ path: scopedPath, query: to.query, hash: to.hash, replace: true })
			return
		}
		const shouldResetOverlay = menuRuntime.shouldResetOverlayForNavigation(to.path, from.path)
		const bootstrapDecision = resolveBootstrapDecision({
			routeadds,
			matchedLength: to.matched.length,
			fullPath: to.fullPath,
			bootstrappedPath,
			isWhitelisted: whitelist.indexOf(to.path) != -1,
			isApplyingRoutes: menuRuntime.isApplyingRoutes(),
			shouldResetOverlay
		})
		debugLog('guard:decision', {
			to: to.fullPath,
			routeadds,
			matched: to.matched.length,
			isWhitelisted: whitelist.indexOf(to.path) != -1,
			shouldResetOverlay,
			shouldBootstrap: bootstrapDecision.shouldBootstrap,
			nextBootstrappedPath: bootstrapDecision.bootstrappedPath
		})
		if (bootstrapDecision.shouldBootstrap) {
			bootstrappedPath = bootstrapDecision.bootstrappedPath
			const bootstrapStart = debugNow()
			menuRuntime.bootstrap(to)          // 据 sessionStorage.routes + 持久 overlay 重建
			debugLog('guard:bootstrap-redirect', {
				to: to.fullPath,
				bootstrapCost: Math.round(debugNow() - bootstrapStart),
				elapsed: Math.round(debugNow() - guardStart)
			})
			next({ path: to.path, query: to.query, hash: to.hash, replace: true })
			return
		}
		bootstrappedPath = bootstrapDecision.bootstrappedPath
		debugLog('guard:allow', {
			to: to.fullPath,
			elapsed: Math.round(debugNow() - guardStart)
		})
		next()
		return
	} else {
		bootstrappedPath = null
		if (whitelist.indexOf(to.path) != -1) {
			debugLog('guard:whitelist', {
				to: to.fullPath,
				elapsed: Math.round(debugNow() - guardStart)
			})
			next()
		} else {
			debugLog('guard:login-redirect', {
				to: to.fullPath,
				elapsed: Math.round(debugNow() - guardStart)
			})
			next({ path: "/login" });
			// if (sessionStorage.getItem('guard_info')) {
			// 	let guard_info = JSON.parse(sessionStorage.getItem('guard_info'))
			// 	//跳转到指定后台登录页
			// 	switch (guard_info.guard_name) {
			// 		default:
			// 			if (type == 0) {
			// 				that.$router.replace({ path: "/adminlogin" })
			// 			} else {
			// 				that.$router.replace({ path: "/login" })
			// 			}
			// 		case 'periphery_admin_user': //联联周边游分后台
			// 			next({ path: "userlogin?name=" + guard_info.name + "&type=" + guard_info.type + "&shop_id=" + guard_info.shop_id + "&guard_name=periphery_admin_user" });
			// 			break;
			// 		case 'periphery_admin_user': //代理后台
			// 			that.$router.replace({ path: "/agentlogin" }) 
			// 		break;
			// 	}
			// } else {
			// 	if (store.state.is_apply) {
			// 		next({ path: "/apply/login" });
			// 	} else {
			// 		next({ path: "/login" });
			// 	}
			// }
		}
	}
});
